module.exports = {
      id: "facebook-circle-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-73eb2de96aa4d32e2310be8fc749a2c5.svg#facebook-circle-color",
      toString: function () {
        return this.url;
      }
    }